import React from "react";
import { Wallet as WalletIcon, CreditCard, Plus, MoreVertical } from "lucide-react";
import "../../styles/settings/wallet.css";

// Button component
const Button = React.forwardRef(({ className, variant = "default", size = "default", ...props }, ref) => {
  const baseClass = "wallet-btn";
  const variantClass = `wallet-btn-${variant}`;
  const sizeClass = `wallet-btn-${size}`;
  const classes = `${baseClass} ${variantClass} ${sizeClass} ${className || ""}`;

  return <button className={classes} ref={ref} {...props} />;
});

// Card components
const Card = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={`wallet-card ${className || ""}`} {...props} />);

const CardHeader = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={`wallet-card-header ${className || ""}`} {...props} />);

const CardTitle = React.forwardRef(({ className, ...props }, ref) => <h3 ref={ref} className={`wallet-card-title ${className || ""}`} {...props} />);

const CardContent = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={`wallet-card-content ${className || ""}`} {...props} />);

const Wallet = () => {
  // Mock data for saved cards
  const savedCards = [
    {
      id: "1",
      last4: "4242",
      brand: "Visa",
      expiryMonth: "12",
      expiryYear: "25",
      isDefault: true,
    },
    {
      id: "2",
      last4: "5555",
      brand: "Mastercard",
      expiryMonth: "08",
      expiryYear: "26",
      isDefault: false,
    },
    {
      id: "3",
      last4: "3782",
      brand: "American Express",
      expiryMonth: "03",
      expiryYear: "27",
      isDefault: false,
    },
  ];

  const getBrandColorClass = (brand) => {
    switch (brand.toLowerCase()) {
      case "visa":
        return "wallet-brand-visa";
      case "mastercard":
        return "wallet-brand-mastercard";
      case "american express":
        return "wallet-brand-amex";
      default:
        return "wallet-brand-default";
    }
  };

  const getCardIcon = (brand) => {
    return <CreditCard className='wallet-card-icon' />;
  };

  return (
    <div className='cp-main-content'>
      <div className='cp-content-container'>
        <div className='cp-header'>
          <div className='wallet-header-content'>
            {/* <WalletIcon className='wallet-header-icon' /> */}
            <div>
              <h1 className='cp-title privacy-data-info-title cp-title'>Wallet</h1>
              <p className='cp-subtitle'>Manage your saved payment methods</p>
            </div>
          </div>
        </div>

        <div className='wallet-content'>
          {/* Add New Card Button */}
          <Button className='wallet-add-card-btn' variant='outline'>
            <Plus className='wallet-plus-icon' />
            Add New Payment Method
          </Button>

          {/* Saved Cards */}
          <div className='wallet-cards-section'>
            <h2 className='wallet-section-title'>Saved Cards</h2>
            {savedCards.map((card) => (
              <Card key={card.id} className='wallet-saved-card'>
                <CardContent className='wallet-saved-card-content'>
                  <div className='wallet-card-row'>
                    <div className='wallet-card-info'>
                      <div className={`wallet-brand-icon ${getBrandColorClass(card.brand)}`}>{getCardIcon(card.brand)}</div>
                      <div>
                        <div className='wallet-card-details'>
                          <span className='wallet-card-brand'>
                            {card.brand} •••• {card.last4}
                          </span>
                          {card.isDefault && <span className='wallet-default-badge'>Default</span>}
                        </div>
                        <p className='wallet-card-expiry'>
                          Expires {card.expiryMonth}/{card.expiryYear}
                        </p>
                      </div>
                    </div>
                    <div className='wallet-card-actions'>
                      {!card.isDefault && (
                        <Button variant='outline' size='sm'>
                          Set as Default
                        </Button>
                      )}
                      <Button variant='ghost' size='sm'>
                        <MoreVertical className='wallet-more-icon' />
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wallet;
